module.exports = __webpack_public_path__ + "img/12.01ea3da3.jpg";